/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import { getGoogleMapLocation } from '../../../../utils/googleMaps';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import DotComponent from '../../../ui/DotComponent';
import CtaLink from '../../../ui/CtaLink';
import { types, sizes } from '../../../ui/CtaLink/types';
import { defaultData } from '../data';
import { containerMarginCss, headlineCss } from './index.styles';

/**
 * Maps the argument to a readable string
 * @param {Array} addresses - parts of an address
 * @returns {string} Formatted address
 */
export const getAddress = addresses =>
  addresses
    .map(address => {
      const { part, separator } = address;

      return part && `${part}${separator || ''}`;
    })
    .join('');

class Headline extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields, defaultData);
    const {
      ProtonName,
      City,
      State,
      ZipCode,
      CountryISOCode,
      Latitude,
      Longitude,
    } = fields;
    const lat = parseFloat(Latitude.value);
    const long = parseFloat(Longitude.value);

    const addresses = CountryISOCode.value === "DNK"
                    ? [
                        { part: ZipCode.value, separator: ', ' },
                        { part: City.value, separator: ', ' },
                        { part: State.value, separator: ' ' },
                        { part: CountryISOCode.value },
                      ]
                    : [
                        { part: City.value, separator: ', ' },
                        { part: State.value, separator: ' ' },
                        { part: ZipCode.value, separator: ', ' },
                        { part: CountryISOCode.value },
                      ];

    return (
      <div css={containerMarginCss}>
        <h1 css={headlineCss}>
          {ProtonName.value}
          <DotComponent />
        </h1>

        <CtaLink
          target="_blank"
          href={getGoogleMapLocation(lat, long)}
          text={getAddress(addresses)}
          type={types.secondary}
          size={sizes.small}
        />
      </div>
    );
  }
}

Headline.displayName = 'LocationHeader/Headline';

Headline.defaultProps = { fields: defaultData };

Headline.propTypes = {
  fields: PropTypes.shape({
    ProtonName: PropTypes.shape({
      value: PropTypes.string,
    }),
    City: PropTypes.shape({
      value: PropTypes.string,
    }),
    State: PropTypes.shape({
      value: PropTypes.string,
    }),
    ZipCode: PropTypes.shape({
      value: PropTypes.string,
    }),
    CountryISOCode: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default Headline;
